import React, {useEffect, useState} from "react";
import { CartProdutLayout } from "../components";
import AddtoCartBtn from "../components/AddtoCartbtn/AddtoCartBtn";
import {  useDispatch,useSelector} from "react-redux";
import { setNavbarDark } from '../../src/appState/slices/auth/authSlice';
import { getUserCart } from "../appState/slices/cart/cartSlice";
import { Link } from "react-router-dom";
const Cart = () => {
    const cart = useSelector(state => state.cart.cart);
    const user = useSelector((state) => state.auth.user);
    const [guestCart, setGuestCart] = useState([]);
    const dispatch = useDispatch()
    useEffect(() => {
  if (user) {
    dispatch(getUserCart());
  } else {
    setGuestCart(
      JSON.parse(localStorage.getItem("guestCart") || "[]")
    );
  }
}, [user]);
    return (
        <div className="cartcontainer">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
            <CartProdutLayout  />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="checkoutdetails">
                <div className="totaldetail">
                    <div className="totalprice t4 font-bold">
                        <div>Total</div>
                        <div>₹ {cart?.totalamount}</div>
                    </div>
                    <h4 className="mrpicl font-semibold t7">
                        excl. taxes
                    </h4>
                </div>
               <AddtoCartBtn name="checkout" action = "checkout" />
            </div>

                    </div>
                </div>
            </div>
            
        </div>
    )
};

export default Cart;